module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between my-3 bold"
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }, [_vm._v(_vm._s(_vm.groupNamesString))]), _vm._v(" "), _c('div', {
    staticClass: "fs-small color-1 pointer normal",
    on: {
      "click": _vm.toggleExpandInfo
    }
  }, [_vm._v(_vm._s(_vm.expanded ? 'hide details' : 'view details'))])]), _vm._v(" "), (_vm.expanded) ? _c('div', [(_vm.productDetailsHasChanges) ? _c('div', {
    staticClass: "fs-small bg-lighter p-2"
  }, _vm._l((_vm.product.changes.details), function(editedField) {
    return _c('div', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(editedField.niceName + ' changed from <b>' + editedField.oldNiceValue + '</b> to <b>' + editedField.newNiceValue + ' </b>')
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.productSalesChannelsHasChanges) ? _c('div', {
    staticClass: "fs-small bg-lighter p-2"
  }, _vm._l((_vm.product.changes.salesChannels), function(editedField) {
    return _c('div', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(editedField.niceName + ' changed from <b>' + editedField.oldNiceValue + '</b> to <b>' + editedField.newNiceValue + ' </b>')
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.productHasAddedGroups) ? _c('div', {
    staticClass: "fs-small bg-lighter p-2"
  }, _vm._l((_vm.product.changes.addedGroups), function(editedField) {
    return _c('div', [_c('div', {
      staticClass: "bold"
    }, [_vm._v("Created group: \"" + _vm._s(editedField.newNiceValue) + "\"")])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.productHasRemovedGroups) ? _c('div', {
    staticClass: "fs-small bg-lighter p-2"
  }, _vm._l((_vm.product.changes.removedGroups), function(editedField) {
    return _c('div', [_c('div', {
      staticClass: "bold"
    }, [_vm._v("Removed group: \"" + _vm._s(editedField.oldNiceValue) + "\"")])])
  }), 0) : _vm._e(), _vm._v(" "), _vm._l((_vm.product.groups), function(group) {
    return (_vm.product.groups.length > 0 && _vm.groupHasChanges(group)) ? _c('div', {
      staticClass: "fs-small bg-lighter p-2"
    }, [(group.id) ? _c('div', [_c('div', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(group.label) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "ml-3"
    }, [(_vm.groupAreaHasChanges(group)) ? _c('div', [_c('div', {
      staticClass: "bold"
    }, [_vm._v("Group:")]), _vm._v(" "), _vm._l((group.editedFields), function(editedField) {
      return (editedField.name != 'dateFrom' && editedField.name != 'dateTo') ? _c('div', [_c('span', {
        domProps: {
          "innerHTML": _vm._s(editedField.niceName + ' changed from <b>' + editedField.oldNiceValue + '</b> to <b>' + editedField.newNiceValue + ' </b>')
        }
      })]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (_vm.schedulesAreaHasChanges(group)) ? _c('div', [_c('div', {
      staticClass: "bold"
    }, [_vm._v("Schedule:")]), _vm._v(" "), _vm._l((group.editedFieldsSchedules), function(editedField) {
      return _c('div', _vm._l((editedField.changes), function(changes) {
        return (changes.name != 'repeatsAtWeekDays') ? _c('div', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(changes.niceName + ' changed from <b>' + changes.oldNiceValue + '</b> to <b>' + changes.newNiceValue + ' </b>')
          }
        })]) : _vm._e()
      }), 0)
    }), _vm._v(" "), _vm._l((group.editedFieldsSchedulesRemoved), function(removedSchedule) {
      return (group.editedFieldsSchedulesRemoved) ? _c('div', [_c('span', {
        domProps: {
          "innerHTML": _vm._s('Removed schedule that started at: <b>' + removedSchedule.niceName + '</b>')
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group.editedFieldsSchedulesAdded), function(addedSchedule) {
      return (group.editedFieldsSchedulesAdded) ? _c('div', [_c('span', {
        domProps: {
          "innerHTML": _vm._s('Added new schedule that starts at: <b>' + addedSchedule.niceName + '</b>')
        }
      })]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (_vm.genderpricesAreaHasChanges(group)) ? _c('div', [_c('div', {
      staticClass: "bold"
    }, [_vm._v("Prices:")]), _vm._v(" "), _vm._l((group.editedFieldsGenderPrice), function(editedField) {
      return _c('div', _vm._l((editedField.changes), function(changes) {
        return _c('div', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(changes.niceName + ' changed from <b>' + changes.oldNiceValue + '</b> to <b>' + changes.newNiceValue + ' </b>')
          }
        })])
      }), 0)
    }), _vm._v(" "), _vm._l((group.editedFieldsGenderPriceRemoved), function(removedGenderPrice) {
      return (group.editedFieldsGenderPriceRemoved) ? _c('div', [_c('span', {
        domProps: {
          "innerHTML": _vm._s('Removed price audience: <b>' + removedGenderPrice.niceName + '</b>')
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group.editedFieldsGenderPriceAdded), function(addedGenderPrice) {
      return (group.editedFieldsGenderPriceAdded) ? _c('div', [_c('span', {
        domProps: {
          "innerHTML": _vm._s('Added new price audience: <b>' + addedGenderPrice.niceName + '</b>')
        }
      })]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (_vm.resourcesAreaHasChanges(group)) ? _c('div', [_c('div', {
      staticClass: "bold"
    }, [_vm._v("Resources:")]), _vm._v(" "), _vm._l((group.editedFieldsResources), function(editedField) {
      return _c('div', _vm._l((editedField.changes), function(changes) {
        return _c('div', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(changes.niceName + ' changed from <b>' + changes.oldNiceValue + '</b> to <b>' + changes.newNiceValue + ' </b>')
          }
        })])
      }), 0)
    }), _vm._v(" "), _vm._l((group.editedFieldsResourcesRemoved), function(removedResource) {
      return (group.editedFieldsResourcesRemoved) ? _c('div', [_c('span', {
        domProps: {
          "innerHTML": _vm._s('Removed resource: <b>' + removedResource.niceName + '</b>')
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group.editedFieldsResourcesAdded), function(addedResource) {
      return (group.editedFieldsResourcesAdded) ? _c('div', [_c('span', {
        domProps: {
          "innerHTML": _vm._s('Added new resource: <b>' + addedResource.niceName + '</b>')
        }
      })]) : _vm._e()
    })], 2) : _vm._e()])]) : _vm._e()]) : _vm._e()
  })], 2) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-c72f9556", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c72f9556"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/components/scheduleGroupChanges.vue
// module id = 995
// module chunks = 0